module.exports = __webpack_public_path__ + "static/media/avatarSmille.8b758905.png";